module.exports = __webpack_public_path__ + "static/media/van.c1959628.jpg";